import { IonContent } from '@ionic/react';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  DominateInputWithOptions,
  OptionType,
} from '@/pages/Onboarding/Layouts/OwnAI_Dominate/components/DominateInputWithOptions';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { ScreenControlStyle } from './SafewordInput.styles';

const options = [
  { id: '1', value: 'Oklahoma', label: 'Oklahoma' },
  { id: '2', value: 'Unicorn', label: 'Unicorn' },
  { id: '3', value: 'Pineapple', label: 'Pineapple' },
];

export const SafewordInput: React.FC = () => {
  const { user } = useAccount();
  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();

  const savedValue = form.watch('safeword_input') || '';
  const [inputValue, setInputValue] = useState<string>(savedValue);

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Safeword Input',
      });
    }
  }, [user]);

  const handleInputChange = (value: string) => {
    setInputValue(value);
  };

  const handleSelect = (option: OptionType) => {
    setInputValue(option.label);
  };

  const handleNextStep = (): void => {
    if (inputValue.trim()) {
      userService.createOrUpdate({
        onboarding_data: {
          safeword_input: inputValue,
        },
      });

      form.setValue('safeword_input', inputValue);

      wizard.nextStep();
    }
  };

  const showContinueButton = inputValue.trim() !== '';

  return (
    <ScreenControlStyle background={'domination'}>
      <OnboardingNavigation />
      <OwnAiTitle>What safeword you would like to use?</OwnAiTitle>
      <IonContent>
        <DominateInputWithOptions
          options={options}
          value={inputValue}
          onChange={handleInputChange}
          onSelect={handleSelect}
          placeholder="Enter your safeword"
        />
      </IonContent>

      {showContinueButton && (
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
        />
      )}
    </ScreenControlStyle>
  );
};
